/* eslint-disable */
import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,

    Use,
    Defs,
    Stop
} from 'react-native-svg';

export const SvgEndorse = ({ size }) => {
    return (<Svg
        height={size}
        width={size}
        viewBox="0 0 74 74" >

        <G id="Bar-with-caption-box" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-333.000000, -43.000000)" strokeLinecap="round" strokeLinejoin="round">
            <G id="Group" transform="translate(335.000000, 45.000000)" stroke="#1A1A1A" strokeWidth="4">
                <Circle id="Oval" cx="22.0060539" cy="63.2017012" r="6.28744397"></Circle>
                <Circle id="Oval" cx="59.7307178" cy="63.2017012" r="6.28744397"></Circle>
                <Path d="M14.6811817,16.0458714 L69.1618837,16.0458714 L63.8804308,42.4216989 C63.2870942,45.4089627 60.6380464,47.5414462 57.5929868,47.4830913 L24.3638454,47.4830913 C21.187056,47.5100355 18.4892846,45.1629744 18.0764014,42.013015 L13.297944,5.79733772 C12.8880726,2.67120759 10.2262559,0.332035381 7.07337447,0.327261459 L0,0.327261459" id="Shape">
                </Path>
            </G>
        </G>

    </Svg>)
}

